<template>
  <div class="categories">
    <h1>
      {{ $filters.translate('T_CATEGORIES') }}
    </h1>
    <div v-for="category in eventCategories"
         class="category"
         :class="{selected:selected.category === category}"
         @click="onClickCategory(category)"
    >
      <span class="dot" :style="{backgroundColor: category.bgColor}" />
      <span class="label">
        {{ $filters.translate(category.name) }}
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: [
    'selected',
    'eventCategories'
  ],
  methods: {
    onClickCategory (category) {
      _.set(this.selected, 'category', category)
      this.$emit('update:selected', _.clone(this.selected))
      this.$emit('change', _.clone(this.selected))
      // this.updateDayList()
    }
  }
}
</script>

<style lang="scss" scoped>

.categories {
  padding: 40px 32px;
  color: #333333;
  background-color: #EDEDED;
  width: 363px;
  min-height: 399px;
  h1 {
    font-family: Poppins-Bold;
    font-size: 20px;
    margin-bottom: 21px;
  }
  .category {
    display: flex;
    align-items: center;
    margin-bottom: 27px;
    cursor: pointer;
    .dot {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
    }
    .label {
      display: inline-block;
      margin-left: 10px;
    }
    &:hover {
      .label {
      color: #888888;
      }
    }
    &.selected {
      pointer-events: none;
      font-family: Poppins-Bold;
    }
  }
}

</style>
